/**
 * The system-managed "Unassigned" group. Devices not assigned to a real
 * location point at this LOCATION_ID. The row exists in the database and
 * cannot be modified or deleted from the admin UI.
 */
export const UNASSIGNED_LOCATION_ID = 0;
